// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"47465947","499":"e07bb328","597":"545eb099","714":"2fb38707","885":"94b29d6b"}[chunkId] + ".chunk.js";
};